import React from 'react';
import {Helmet} from 'react-helmet';

export default function Fonts() {
  return (
    <Helmet>
      <link
        rel='stylesheet'
        href='https://fonts.googleapis.com/icon?family=Material+Icons'
      />
      <link
        rel='preload'
        href='/fonts/Orca-Bold-kern-latin.woff2'
        as='font'
        type='font/woff2'
        crossOrigin='anonymous'
      />
      <link
        rel='preload'
        href='/fonts/Orca-Regular-kern-latin.woff2'
        as='font'
        type='font/woff2'
        crossOrigin='anonymous'
      />
      <link
        rel='preload'
        href='/fonts/Orca-Medium-kern-latin.woff2'
        as='font'
        type='font/woff2'
        crossOrigin='anonymous'
      />
      <script type='text/javascript'>
        {`
        if( "fonts" in document ) {
            var regular = new FontFace("Orca", "url(/fonts/Orca-Regular.woff2) format('woff2'), url(/fonts/Orca-Regular.woff) format('woff')");
            var medium = new FontFace("Orca", "url(/fonts/Orca-Medium.woff2) format('woff2'), url(/fonts/Orca-Medium.woff) format('woff')", { weight: "600" });
            var bold = new FontFace("Orca", "url(/fonts/Orca-Bold.woff2) format('woff2'), url(/fonts/Orca-Bold.woff) format('woff')", { weight: "700" });

            Promise.all([ bold.load(), medium.load(), regular.load() ]).then(function(fonts) {
                fonts.forEach(function(font) {
                    document.fonts.add(font);
                });
            });
        }
      `}
      </script>
      <style type='text/css'>
        {`
          @font-face {
            font-family: 'Orca';
            src: url(/fonts/Orca-Bold-kern-latin.woff2) format("woff2"),
            url(/fonts/Orca-Bold-kern-latin.woff) format("woff");
            font-weight: 700;
            font-display: swap;
          }
          @font-face {
            font-family: 'Orca';
            src: url(/fonts/Orca-Medium-kern-latin.woff2) format("woff2"),
            url(/fonts/Orca-Medium-kern-latin.woff) format("woff");
            font-weight: 600;
            font-display: swap;
          }
          @font-face {
            font-family: 'Orca';
            src: url(/fonts/Orca-Regular-kern-latin.woff2) format("woff2"),
            url(/fonts/Orca-Regular-kern-latin.woff) format("woff");
            font-weight: 400;
            font-display: swap;
          }
        `}
      </style>
    </Helmet>
  );
}
